import { getUrlParam, getPageSearch } from '@/utils';
import { alwaysNotVisibleBlocks } from '@/constants';

export function getInitialElementValue(block = {}) {
	let preselectScoreValue = null;

	//the old way passing values through querystring
	if (block.properties?.preselectScore) {
		switch (block.typeName) {
			case 'nps':
			case 'thumbs':
				preselectScoreValue = getUrlParam(block.typeName, getPageSearch());
				break;

			case 'rating':
			default:
				if (block.properties.type === 'emoji') {
					preselectScoreValue = getUrlParam('smiley', getPageSearch());
					if (
						preselectScoreValue &&
						block.properties.labelsAsValue &&
						block.properties.labelsAsValue
					) {
						preselectScoreValue =
							block.properties.emoji?.[preselectScoreValue]?.label ?? '';
					}
					break;
				}
				preselectScoreValue = getUrlParam('score', getPageSearch());
		}

		if (preselectScoreValue) {
			return {
				post: true,
				logic: true,
				value: preselectScoreValue
			};
		}
	}

	//the new way of passing values through querystring
	const urlParamValue =
		getUrlParam(`${block.typeName}_${block.id}`, getPageSearch()) ||
		getUrlParam(`${block.typeName}_${block.uuid}`, getPageSearch());

	if (urlParamValue) {
		return {
			post: true,
			logic: true,
			value: urlParamValue
		};
	}

	if (block.properties?.value) {
		return {
			logic: true,
			value: block.properties.value
		};
	}

	return {
		value: ''
	};
}

export function isNestedStateProp(str = '') {
	return (
		['dom', 'selector'].indexOf(str) > -1 || //handle screenshot nested state
		!isNaN(Number(str))
	);
}

export function getCurrentVisibleId({ layout, blockState, blocks }) {
	return (
		layout
			.filter(blockId => {
				const state = blockState[blockId];
				const block = blocks[blockId];
				return (
					state.isVisible &&
					state.showInConvo &&
					alwaysNotVisibleBlocks.indexOf(block?.typeName) === -1
				);
			})
			.pop() ?? null
	);
}

export function getNextVisibleId({ layout, blockState, blocks }) {
	const currentVisibleBlockId = getCurrentVisibleId({ layout, blockState, blocks });
	const currentIndex = layout.indexOf(currentVisibleBlockId);
	const nextVisibleId = layout.slice(currentIndex + 1, layout.length).filter(blockId => {
		const state = blockState[blockId];
		const block = blocks[blockId];
		return state.isVisible && alwaysNotVisibleBlocks.indexOf(block.typeName) === -1;
	})[0];

	return nextVisibleId;
}
